import { render } from "./insights-left-panel-full.vue?vue&type=template&id=8a54a2d7&scoped=true"
import script from "./insights-left-panel-full.vue?vue&type=script&lang=js"
export * from "./insights-left-panel-full.vue?vue&type=script&lang=js"

import "./insights-left-panel-full.vue?vue&type=style&index=0&id=8a54a2d7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a54a2d7"]])

export default __exports__